import { Flex, Text } from '@chakra-ui/react';
import ListItem from 'common/components/list-item';
import { formatDateToHumanDate } from 'common/utils/formDateToHumanTime';
import moment from 'moment';
import { BiSolidBadgeCheck } from 'react-icons/bi';
import { FaCheck, FaCreditCard, FaFileSignature } from 'react-icons/fa6';

const WhatsNextQuote = ({ planData }) => {
  // Set up dates for what's next
  const signDate = planData?.lease?.signDate
    ? moment(planData?.lease?.signDate)
    : null;

  if (signDate) {
    return (
      <>
        <ListItem
          title={
            <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
              <Text>Get a Quote</Text>
              <Text className='text-sm'>Today</Text>
            </Flex>
          }
          description='Expect an email with your quote details shortly.'
          ListIcon={FaCheck}
          complete
          line
        />
        <ListItem
          title={
            <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
              <Text>Purchase Coverage</Text>
              <Text className='text-sm'>By {formatDateToHumanDate(signDate.add(7,'days'))}</Text>
            </Flex>
          }
          description={
            <span>
              Add some personal details and purchase coverage within <span className='font-medium'>7 days of when you signed your lease</span>. If you change your mind before move-in, you can cancel coverage at no cost.
            </span>
          }
          ListIcon={FaCreditCard}
          line
        />
        <ListItem
          title={
            <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
              <Text>Activate Plan</Text>
            </Flex>
          }
          description='Sign your finalized lease agreement and upload it alongside a copy of your government-issued ID. We’ll review and confirm your details to activate your plan.'
          ListIcon={BiSolidBadgeCheck}
        />
      </>
    );
  }

  // Otherwise use the preLease text
  return (
    <>
      <ListItem
        title={
          <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
            <Text>Get a Quote</Text>
          </Flex>
        }
        description='Expect an email with your quote details shortly. Create as many quotes as you’d like, at as many properties as you’d like, and find them all under your plans page.'
        ListIcon={FaCheck}
        complete
        line
      />
      <ListItem
        title={
          <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
            <Text>Apply for Rentals</Text>
          </Flex>
        }
        description='Decide on a unit and finalize your lease details like your monthly rent price, lease term, and layout. If one or more of these changes after today, create a new quote to get updated pricing.'
        ListIcon={FaFileSignature}
        line
      />
      <ListItem
        title={
          <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
            <Text>Purchase Coverage</Text>
          </Flex>
        }
        description='Add some personal details and purchase coverage. If you change your mind before move-in, you can cancel coverage at no cost.'
        ListIcon={FaCreditCard}
        line
      />
      <ListItem
        title={
          <Flex className='w-full sm:justify-between gap-1 mb-1.5 sm:items-center flex-col-reverse sm:flex-row'>
            <Text>Sign and Activate</Text>
          </Flex>
        }
        description='Sign your finalized lease agreement and upload it alongside a copy of your government-issued ID. We’ll review and confirm your details to activate your plan.'
        ListIcon={BiSolidBadgeCheck}
      />
    </>
  );
};

export default WhatsNextQuote;
